import { useQuery, UseQueryResult } from 'react-query';
import { UrlParams, ProgramRetrieve } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

interface IUseProgramMonthProps {
  start?: string;
  end?: string;
  kiloClassTypes?: string[];
  enabled?: boolean;
}

function useProgramCalendar({
  start,
  end,
  kiloClassTypes,
  enabled = true,
}: IUseProgramMonthProps = {}): UseQueryResult<{ data: Array<ProgramRetrieve> }> {
  const params: UrlParams = {};

  if (start) {
    params.start = start;
  }
  if (end) {
    params.end = end;
  }
  if (kiloClassTypes && kiloClassTypes.length > 0) {
    params.kilo_class_types = kiloClassTypes.join(',');
  }

  return useQuery(
    ['programs', 'calendar', enabled, start, end, kiloClassTypes],
    () => client.get(`programs/calendar/?${encodeUrlParams(params)}`),
    {
      enabled: enabled && !!start && !!end && end >= start,
    },
  );
}

export default useProgramCalendar;
